import { render, staticRenderFns } from "./Bedrijven.vue?vue&type=template&id=30f5e0c6&"
import script from "./Bedrijven.vue?vue&type=script&lang=js&"
export * from "./Bedrijven.vue?vue&type=script&lang=js&"
import style0 from "./Bedrijven.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Bedrijven.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VFlex,VImg,VRow})
